/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSchemaResponseModel } from '../../models/document-schema-response-model';

export interface ApiDocumentSchemasContractsSchemasGet$Json$Params {
}

export function apiDocumentSchemasContractsSchemasGet$Json(http: HttpClient, rootUrl: string, params?: ApiDocumentSchemasContractsSchemasGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentSchemaResponseModel>>> {
  const rb = new RequestBuilder(rootUrl, apiDocumentSchemasContractsSchemasGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentSchemaResponseModel>>;
    })
  );
}

apiDocumentSchemasContractsSchemasGet$Json.PATH = '/api/DocumentSchemas/contracts-schemas';
